import React from "react";
 
const Popup = props => {
  return (
    <>
    {/* ----------------------mobile view--------------------- */}
    <div className="mobile_popup-box d-lg-none d-md-block">
      <div className="mobile_box">
        <span className="mobile_close-icon" onClick={props.handleClose}>x</span>
        {props.content}
      </div>
    </div>


    {/* ----------------------desktop view--------------------- */}
    <div className="popup-box d-none d-lg-block">
      <div className="box">
        <span className="close-icon" onClick={props.handleClose}>x</span>
        {props.content}
      </div>
    </div>
    
    
    </>
    
    
  );
};
 
export default Popup;